// extracted by mini-css-extract-plugin
export var centerList = "_hz-6";
export var centerLoc = "_hz-a";
export var centerName = "_hz-9";
export var centerOptionBody = "_hz-8";
export var centerRow = "_hz-7";
export var centerStatus = "_hz-b";
export var empty = "_hz-5";
export var externalIcon = "_hz-c";
export var fieldHeader = "_hz-2";
export var fieldHelp = "_hz-4";
export var fieldLabel = "_hz-3";
export var panel = "_hz-0";
export var removeBtn = "_hz-d";
export var section = "_hz-1";